import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;fill-rule:evenodd;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "arrow-left-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M16.25,23.25,5.53,12.53a.749.749,0,0,1,0-1.06L16.25.75"
		})
	]
});
export default SvgArrowLeft1;
